import React, { lazy, Suspense, useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as urls from "../../utils/URLConst";
import toastNotify from "../../utils/ToastNotify";
import { computeCrc } from "../../utils/CRC32";
import { removeLoginSession, AuthKey, encData } from "../../utils/Common";
import TextField from "../../componants/textField/TextField";
import { Button, Row, Col } from "react-bootstrap";
import { getCaptchaCode } from "../../apiService/ApiServices";
import { BiEnvelope, BiLoader, BiPhone, BiRefresh } from "react-icons/bi";
import FullScreenLoader from "../../componants/loader/FullScreenLoader";
const LoginLayout = lazy(() => import('./LoginLayout'));

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isCaptchaLoader, setIsCaptchaLoader] = useState(false);
  const [captchaDtl, setCaptchaDtl] = useState(null);
  const [isFullLoader, setIsFullLoader] = useState(false);

  const getRegularCaptcha = async () => {
    setIsCaptchaLoader(true);
    const data = await getCaptchaCode()
    setCaptchaDtl(data);
    setIsCaptchaLoader(false);
  }

  useEffect(() => {
    setIsFullLoader(true);
    setTimeout(() => {
      setIsFullLoader(false);
      getRegularCaptcha();
      sessionStorage.setItem("reloadflag", "0");
    }, 3000);
  }, []);

  async function handleSubmit(val, resetForm) {
    try {
      setIsLoading(true);

      const identifyData = JSON.parse(localStorage.getItem("_identityData"));

      const payload = {
        MOBILE_NO: captchaDtl?.authType === "S" ? encData(val.mobileNo) : "",
        EMAIL: captchaDtl?.authType === "M" ? encData(val.emailId) : "",
        CAPTCHA_CD: encData(val.enterCaptcha),
        SESSION_ID: captchaDtl?.sessionId,
        DOMAIN_NM: window.location.hostname,
        IP_ADDRESS: identifyData?.ip || "",
      };

      const shareData = {
        MOBILE_NO: captchaDtl?.authType === "S" ? val.mobileNo : "",
        EMAIL: captchaDtl?.authType === "M" ? val.emailId : "",
        CAPTCHA_CD: val.enterCaptcha,
        SESSION_ID: captchaDtl?.sessionId,
        DOMAIN_NM: window.location.hostname,
        IP_ADDRESS: identifyData?.ip || "",
      }

      const checksum = computeCrc(JSON.stringify(payload));

      await axios({
        method: "POST",
        url: urls.LoginClientAuth,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          checksum: checksum,
          Authorization: AuthKey,
        },
      }).then((result) => {
        if (result.data.STATUS === "0") {
          toastNotify(result.data.MESSAGE, "success");
          navigate("/otp", { state: { ...shareData, ...result.data.RESPONSE[0], authType: captchaDtl?.authType } });
        } else {
          resetForm();
          getRegularCaptcha();
          toastNotify(result.data.MESSAGE, "error");
        }
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    removeLoginSession();
  }, []);

  return (
    <>
      {!isFullLoader ?
        <Suspense fallback={<FullScreenLoader />}>
          <LoginLayout>
            <Formik
              initialValues={{
                mobileNo: "",
                emailId: "",
                enterCaptcha: "",
              }}
              validationSchema={Yup.object().shape({
                mobileNo: captchaDtl?.authType === "S" ? Yup.string().required("Register Mobile No. is required field") : Yup.string(),
                emailId: captchaDtl?.authType === "M" ? Yup.string().required("Register Email Id is required field") : Yup.string(),
                enterCaptcha: Yup.string().required("Captcha Code is required field"),
              })}
              onSubmit={(value, { resetForm }) => handleSubmit(value, resetForm)}
            >
              {({ values, setFieldValue, handleBlur, handleChange }) => (
                <Form>
                  <div className="mt-3 text-sm">Login to access smart CRM</div>
                  <div className="mt-2">
                    {captchaDtl?.authType === "S" &&
                      <div>
                        <TextField
                          label="Register Mobile No."
                          name="mobileNo"
                          id="mobileNo"
                          maxLength={10}
                          tabIndex={1}
                          required
                          value={values.mobileNo}
                          onChange={(e) => {
                            const { value } = e.target;
                            const regex = /^[0-9]*[.,]?[0-9]*$/;
                            if (regex.test(value.toString())) {
                              setFieldValue("mobileNo", value);
                            }
                          }}
                          onBlur={handleBlur}
                          IconProp={BiPhone}
                        />
                        <ErrorMessage name="mobileNo" component="div" className="error-msg" />
                      </div>
                    }
                    {captchaDtl?.authType === "M" &&
                      <div>
                        <TextField
                          label="Register Email Id"
                          name="emailId"
                          id="emailId"
                          style={{ fontSize: 15 }}
                          className="text-sm"
                          maxLength={50}
                          tabIndex={1}
                          required
                          value={values.emailId}
                          onChange={(e) => {
                            const { value } = e.target;
                            setFieldValue("emailId", value.toLowerCase());
                          }}
                          onBlur={handleBlur}
                          IconProp={BiEnvelope}
                        />
                        <ErrorMessage name="emailId" component="div" className="error-msg" />
                      </div>
                    }

                    <Row className="mt-3">
                      <Col xs={6}>
                        <div className="d-flex">
                          <div className="form-control form-control-sm p-1 capcha-input"
                            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: "#f0f0f0", height: 35 }}>
                            <img src={captchaDtl?.captchaImage ? "data:image/jpeg;base64," + captchaDtl?.captchaImage : ""} alt="captcha" className="w-100 h-100" />
                          </div>
                          <Button variant='primary' disabled={isCaptchaLoader} type="button" className="btn-sm" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                            onClick={() => {
                              getRegularCaptcha();
                            }}>
                            {isCaptchaLoader ? <BiLoader className="bx-spin text-white text-lg" /> : <BiRefresh className='text-white text-lg' />}
                          </Button>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <TextField
                          label="Captcha"
                          name="enterCaptcha"
                          id="enterCaptcha"
                          tabIndex={2}
                          maxLength={8}
                          required

                          disabled={isLoading}
                          value={values.enterCaptcha}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage name="enterCaptcha" className='error-msg' component="div" />
                      </Col>
                    </Row>

                    <div className="mt-4">
                      <Button
                        type="submit"
                        variant="primary"
                        tabIndex={3}
                        className="w-100"
                        disabled={isLoading}
                      >
                        {!isLoading ? "Login" :
                          <>
                            <BiLoader className="bx-spin text-white text-lg me-2" />{" "}
                            Loading...
                          </>
                        }
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </LoginLayout>
        </Suspense>
        :
        <FullScreenLoader />
      }
    </>
  );
};

export default Login;
